<template>
  <!-- 页面头部 -->
  <div class="box">
    <div class="box-top">
      <div class="nav-left">
        <img src="@/assets/images/logo.png"/>
        <img src="@/assets/images/logo2.png"/>
      </div>
      <div class="nav-right">
        <img src="@/assets/images/h2.png"/>
        <el-input v-model="input" placeholder="输入您想搜索的内容: 新闻、科室、科普..."></el-input>
        <div class="nav-bt" @click="onClickRoute">搜索</div>
      </div>
    </div>
    <div class="nav-box">
      <div class="nav-ul">
        <!-- 使用 v-for 循环渲染导航项，点击时动态设置 active 类 -->
        <div
          class="nav-li"
          v-for="(item, index) in List"
          :key="index"
          :class="{'active': selectedIndex === index}"
          @click="selectTitle(index, item)"
        >
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "siteNav",
  props: {
    selectedIndex: {
      type: Number,
      default: 0 // 默认选中第一个
    }
  },
  data() {
    return {
      input: '',
      List: ['首页', '质控课程', '新闻资讯', '会议直播', '科普知识', '质控网络', '质控公告', '指南共识', '关于我们'],
      PageList: [
        '/course', // 质控课程
        '/NewsInformation', // 科普知识
        '/Meeting', // 会议直播
        '/Network', // 质控网络
        '/Announcement', // 质控公告
        '/Handbook', // 指南共识
        '/Information', // 新闻资讯
      ],
    };
  },
  methods: {
    onClickRoute() {
      let token = localStorage.getItem("x-token")
      if(token == null) {
        this.$router.push({ path: `/codeLogin` });
        return
      }
      let pageIndex =  this.PageList.findIndex(item => item == this.$route.path)
      if(pageIndex != -1) {
        this.$router.push({ path: `${this.PageList[pageIndex]}?title=${this.input}` });
      }else {
        this.$router.push({ path: `/Search?title=${this.input}` });
      }
    },
    selectTitle(index, item) {
      let token = localStorage.getItem("x-token")
      if(item != '首页' && token == null) {
        this.$router.push({ path: `/codeLogin` });
        return
      }
      // 更新父组件的 selectedIndex
      this.$emit('update:selectedIndex', index);
      // 跳转到对应的路由
      this.$router.push(this.getRoute(item));
    },
    getRoute(title) {
      const routes = {
        '首页': '/index',
        '质控课程': '/course',
        '新闻资讯': '/Information',
        '会议直播': '/Meeting',
        '科普知识': '/NewsInformation',
        '质控网络': '/Network',
        '质控公告': '/Announcement',
        '指南共识': '/Handbook',
        // '论坛中心': '/ForumCenter',
        '关于我们': '/CenterProfile',
      };
      return routes[title] || '/home';
    }
  },
};
</script>

<style scoped lang="less">
  .box {
    background: url("~@/assets/images/head-bg.png") no-repeat;
    background-size: 100% 100%;
  }
  .box-top{
    display: flex;
    align-items: center;
    width: 1300px;
    margin: auto;
    justify-content: space-between;
    height: 120px;
    .nav-left{
      display: flex;
      align-items: center;
      justify-content: center;
      img:first-child{
        width: 60px;
        margin-right: 10px;
        display: block;
      }
      img:last-child{
        width: 336px;
        display: block;
      }
    }
  }
  .nav-box {
    width: 1300px;
    margin: auto;
  }
  .nav-ul {
    display: flex;
    align-items: center;
    background: rgba(164, 18, 24, 1);
  }
  .nav-li {
    font-size: 16px;
    color: #fff;
    width: 162.5px;
    text-align: center;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 16px;
  }
  .nav-li.active {
    background: rgba(141, 29, 34, 1);
    font-weight: bold;
  }
  .nav-right {
    background: #fff;
    border-radius: 8px;
    width: 500px;
    height: 46px;
    display: flex;
    padding: 0 6px 0 12px;
    align-items: center;
    border: 1px solid rgba(156, 29, 34, 1);
    img {
      width: 20px;
      margin-right: 6px;
    }
    /deep/.el-input__inner {
      border: none !important;
      background: transparent;
      height: 36px;
      padding-left: 0;
    }
    .nav-bt {
      background: #9C1D22;
      width: 86px;
      height: 36px;
      font-size: 14px;
      color: #fff;
      line-height: 36px;
      border-radius: 6px;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/base/siteNav.vue